<template>
  <div>
    <div class="app-os">iOS</div>
    <div class="app-image">
      <div class="app-image--detail">
        <p class="app-description">{{ Link.runkeeperMap[lang] }}</p>
        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-ios-app-map.png`"
          width="270"
          alt=""
          class="img"
        />
      </div>
      <div class="app-image--detail">
        <p class="app-description">{{ Link.runkeeperMenu[lang] }}</p>

        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-ios-app-menu.png`"
          width="270"
          alt=""
          class="img"
        />
      </div>
    </div>
    <div class="app-os">Android</div>
    <div class="app-image">
      <div class="app-image--detail">
        <p class="app-description">{{ Link.runkeeperMapAndroid[lang] }}</p>
        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-android-app-map.png`"
          width="270"
          alt=""
          class="img"
        />
      </div>
      <div class="app-image--detail">
        <p class="app-description">{{ Link.runkeeperMenu[lang] }}</p>
        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-android-app-menu.png`"
          width="270"
          alt=""
          class="img"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Link: Object,
    lang: String,
  },
  name: "RunkeeperCapture",
};
</script>

<style scoped>
.app-os {
  margin: 48px 0 0 0;
  text-align: center;
  font-size: 32px;
}
.app-image {
  margin: 16px 0 0 0;
  display: flex;
  justify-content: center;
  &--detail {
    margin: 0 16px;
    width: 270px;
    .app-description {
      height: 36px;
    }
    img {
      margin: 16px 0 0 0;
      box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/oauth/RunkeeperCapture.vue